<div class="card height-equal">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5 class="m-0">{{ 'HR Activity' | translate }}</h5>
      <!-- Optional Dropdown for date selection can be uncommented if needed
      <div class="card-header-right-icon">
        <div class="dropdown">
          <button class="btn dropdown-toggle" type="button" (click)="toggle()">{{ 'Today' | translate }}</button>
          <div class="dropdown-menu dropdown-menu-end" [class.show]="show">
            <a class="dropdown-item" href="#">{{ 'Today' | translate }}</a>
            <a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a>
            <a class="dropdown-item" href="#">{{ 'Yesterday' | translate }}</a>
          </div>
        </div>
      </div>
      -->
    </div>
  </div>
  <div class="card-body pt-0 div-scrollable">
    <span class="help-icon fas fa-info-circle"
        ngbTooltip="✨ This is a cute tooltip! ✨"
        placement="top"
        container="body"></span>
    <ul *ngIf="activity.length > 0; else noDataTemplate">
      <li class="d-flex" *ngFor="let item of activity; let i = index;">
        <div class="activity-dot-{{colors[i]}}"></div>
        <div class="w-100 ms-3">
          <p class="d-flex justify-content-between mb-2">
            <span class="date-content light-background">{{item.created_at | date}}</span>
            <span>{{item.created_at | date:'H:m:s' }}</span>
          </p>
          <h6>{{item.action | titlecase | translate}}<span class="dot-notification"></span></h6>
          <p class="f-light">{{item.description}}</p>
        </div>
      </li>
    </ul>
    <ng-template #noDataTemplate>
      <p class="text-center">{{ 'No data found' | translate }}</p>
    </ng-template>
  </div>
</div>
